import { getValueByPath } from '@/commons/filters';
import { HTTP_STATUS } from '@/metas/common';
import router from '@/router';
import { UserModule } from '@/store/modules/user';
import { AxiosResponse } from 'axios';
import { Notify } from 'vant';
import { ErrorHandler, FullFilledHandler, RequestInterceptor } from './client.factory';

export const responseHandlerProducer =
    (responseKey: string | null = 'data'): FullFilledHandler => (response) => {
        const result = response.data;
        if (!result) { return result; }
        if (response.headers && response.headers.token) {
            result.token = response.headers.token;
        }
        if (typeof result === 'object') {
            result.code = Number(result.code);
            switch (result.code || undefined) {
            case HTTP_STATUS.SUCCESS[0]:
                if (result.errors && result.errors.length) {
                    let errorMsgHtml = '';
                    // @ts-ignore
                    result.errors.forEach((error) => {
                        errorMsgHtml += `${error.message}`;
                    });
                    Notify({ type: 'success', message: errorMsgHtml });
                }
                return result;
            case HTTP_STATUS.PARAMETER_ERROR[0]:
                return Promise.reject(result.message || 'error');
            default:
                // if (!responseKey || !result[responseKey]) {
                //     Notify({ type: 'danger', message: result.message });
                // }
                return result;
            }
        }
        return result;
    };

/**
 * 请求携带token
 */
export const requestInterceptor = (auth: boolean = false) => (config: any) => {
    const { userToken } = UserModule;
    if (userToken) {
        return { ...config, headers: { ...config.headers, token: `${userToken}` } };
    }
    return config;
};

interface NetError {
    code: string;
    i18n: string;
    message: string;
    params?: { ['message']: string };
}

function getErrorMsg(error: NetError) {
    const errorMsg = (error.params && error.params.message) || error.message;
    return errorMsg;
}

/**
 * 对请求返回的数据进行处理
 */
export const handlerErrorMsg = (response: AxiosResponse): any => {
    if (!response) { return false; }
    let msg = '';
    let errors: any[] = [];
    switch (response.status) {
    case HTTP_STATUS.BAD_REQUEST[0]:
        const error = getValueByPath(response, 'data.error', null);
        if (error) {
            const errorDescription = getValueByPath(response, 'data.error_description', null);
            if (errorDescription) {
                switch (errorDescription) {
                case 'Bad credentials':
                    msg = '账户或密码错误';
                    break;
                default:
                    msg = errorDescription;
                }
            } else {
                msg = error;
            }
            break;
        }
        // eslint-disable-next-line prefer-destructuring
        errors = getValueByPath(response, 'data.errors', null);
        if (errors != null && errors.length > 0) {
            msg = errors.map((e) => getErrorMsg(e)).join('、');
        } else {
            msg = response.data.message;
        }
        break;
    case HTTP_STATUS.FORBIDDEN[0]:
        msg = '无权限';
        router.replace('/403');
        break;
    case HTTP_STATUS.UNAUTHORIZED[0]:
        msg = '授权已过期';
        console.log(response);
        // // UserModule.SET_USER_TOKEN('');
        // const env = process.env.VUE_APP_ENV !== 'prd' ? `${process.env.VUE_APP_ENV}%2f` : '';
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwf379af21bfd1f428&redirect_uri=https%3a%2f%2fwww.lianxincloud.com%2f${env}zm%2fmobile%2fadmin%3ft%3d333&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
        // router.replace({ path: '/auto/login' });
        break;
    case HTTP_STATUS.SERVER_ERROR[0]:
    default:
        // eslint-disable-next-line prefer-destructuring
        msg = HTTP_STATUS.SERVER_ERROR[1];
    }
    if (msg !== '授权已过期') {
        Notify({ type: 'danger', message: msg });
    }
    return Promise.reject(msg);
};

/**
 * 错误统一处理
 */
export const errorHandler: ErrorHandler = (error: any) => {
    // error没有message
    if (!error.message) {
        Notify({ type: 'danger', message: '未知错误' });
        return Promise.reject(error);
    }
    // 请求超时错误
    if (error.message.includes('timeout of 5000ms exceeded')) {
        Notify({ type: 'danger', message: '请求超时' });
        return Promise.reject(error);
    }
    // 网络错误
    if (!error.response) {
        Notify({ type: 'danger', message: '未知错误' });
        return Promise.reject(error);
    }
    if (error.response.message === 'Network Error') {
        Notify({ type: 'danger', message: '网络错误' });
        return Promise.reject(error);
    }
    if (error.response.status) {
        const errorMsg = handlerErrorMsg(error.response);
        return Promise.reject(errorMsg);
    }
    return Promise.reject(new Error('未知错误'));
};
